import { type ComponentChildren } from 'preact'
import { Link } from 'wouter-preact'
import { clsx } from 'clsx'

import { Typography } from 'components/UI/atoms'

type Props = {
	text: string
	href?: string
	icon?: ComponentChildren
	onClick?: () => void
	className?: string
	variant?: 'normal' | 'small'
}

const ViewMoreButton = ({
	text,
	href,
	icon,
	onClick,
	className,
	variant = 'normal'
}: Props) => {
	const typographyVariant = variant === 'small' ? 'text4' : 'text3'

	if (href) {
		return (
			<Link class='group flex items-center' href={href}>
				<Typography
					class='mr-2'
					color='text-black-100'
					text={text}
					variant={typographyVariant}
				/>
				{icon}
			</Link>
		)
	}

	return (
		<button
			class={clsx(
				'group flex items-center focus:outline-transparent',
				className
			)}
			onClick={onClick}
			type='button'
		>
			<Typography
				class='mr-2'
				color='text-black-100'
				text={text}
				variant={typographyVariant}
			/>
			{icon}
		</button>
	)
}

export { ViewMoreButton }
